export const isMobile = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileDevice =
    /android|webos|iphone|ipad|ipod|blackberry|windows phone|iemobile|mobile safari|opera mini/i.test(
      userAgent,
    );

  return isMobileDevice;
};
